module.exports = __webpack_public_path__ + "static/img/4.9dcca95.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/article/4.jpg
// module id = nB17
// module chunks = 1